// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__HHUFx","requiredAsterisk":"Info_requiredAsterisk__KT4vQ"};